import styled from "styled-components";

export const TabelaTalhãoPropriedade = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;